import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { LanguageProvider } from "./i18n";
import { Toaster } from "./components/ui/sonner";

// Pagesuyyyy=-y0
import LandingPage from "./pages/LandingPage";
import AuthPage from "./pages/AuthPage";
import DashboardPage from "./pages/DashboardPage";
import TontinesPage from "./pages/TontinesPage";
import TontineDetailPage from "./pages/TontineDetailPage";
import ContributionsPage from "./pages/ContributionsPage";
import ChatPage from "./pages/ChatPage";
import ReferralsPage from "./pages/ReferralsPage";
import NotificationsPage from "./pages/NotificationsPage";
import JoinPage from "./pages/JoinPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import ProfilePage from "./pages/ProfilePage";
import SettingsPage from "./pages/SettingsPage";

// Components
import ProtectedLayout from "./components/ProtectedLayout";
import AdminRoute from "./components/AdminRoute";
import PWAInstallButton from "./components/PWAInstallButton";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/join/:inviteCode" element={<JoinPage />} />

            {/* Protected routes */}
            <Route element={<ProtectedLayout />}>
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/tontines" element={<TontinesPage />} />
              <Route path="/tontines/new" element={<TontinesPage />} />
              <Route path="/tontines/:id" element={<TontineDetailPage />} />
              <Route path="/contributions" element={<ContributionsPage />} />
              <Route path="/chat" element={<ChatPage />} />
              <Route path="/referrals" element={<ReferralsPage />} />
              <Route path="/notifications" element={<NotificationsPage />} />
              <Route element={<AdminRoute />}>
                <Route path="/admin" element={<AdminDashboardPage />} />
              </Route>
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/settings" element={<SettingsPage />} />
            </Route>

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          {/* PWA Install Banner */}
          <PWAInstallButton variant="banner" />
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
